import { Image } from "@nextui-org/react";
import { STORAGE_LINK } from "@/utils/constants";

function Question({ question, image }) {
  return (
    <div className="p-10 text-center rounded-lg bg-white-color border border-gray-200 shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px]">
      <p className="mb-5 text-xl font-semibold text-blue-color-primary">{question}</p>
      {image && (
        <Image
          src={`${STORAGE_LINK}/${image}`}
          loading="lazy"
          alt={`question : ${question} image`}
          width={500}
          classNames={{
            wrapper: "mx-auto flex justify-center",
          }}
        />
      )}
    </div>
  );
}

export default Question;
